import React from 'react';

const Star = ({ fill }) => {
  const imageSrc = `/assets/images/stars/${fill}.png`;
  return <img className="product-rating__star" src={imageSrc} alt="star" />;
};

export default Star;
